module.exports = __webpack_public_path__ + "static/media/login-bg.57a7e0f1.png";